export default __webpack_public_path__ + "static/media/chimpy.8defbd8c.png";